module.exports = __webpack_public_path__ + "assets/img/Instagram.c39bca3a.svg";